import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { PayStation } from 'src/features/payment/utils/types';
import { PayStationFormSchemaValues } from 'src/features/payment/utils/formSchema';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/paystations/pay-station/:payStationId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    data: PayStationFormSchemaValues;
    payStationId: string;
}
const mutationFn = ({ payStationId, data }: DTO): Promise<PayStation> => {
    return axios.patch(formatResourcePath(RESOURCE, { payStationId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePayStation };
